const styles = {
  title: {
    padding: '16px 16px 16px 0px',
    position: 'relative',
    fontSize: '24px',
    color: 'rgba(0, 0, 0, 0.87)',
    display: 'block',
    lineHeight: '36px'
  },
  statsHeading: {
    fontSize: '16px',
    letterSpacing: '0.15px',
    fontWeight: '400',
    position: 'absolute'
  },
  statTitle: {
    fontSize: '13px',
    lineHeight: '45px',
    color: 'rgba(0, 0, 0, 0.54)',
    textAlign: 'center',
    fontWeight: '500'
  },
  statValue: {
    fontSize: '56px',
    lineHeight: '80px',
    textAlign: 'center',
    paddingTop: '15px'
  },
  label: {
    textAlign: 'right'
  },
  toggle: {
    backgroundColor: '#252CAB'
  },
  toggleBackround: {
    backgroundColor: 'rgba(37, 44, 171, 0.5)'
  },
  cardContainer: {
    display: 'flex',
    height: 'auto',
    padding: '20px 0 40px 0'
  },
  card: {
    width: '100%'
  },
  description: {
    padding: '20px'
  },
  border: {
    borderTop: '1px solid #03020214'
  },
  table: {
    width: '95%',
    margin: 'auto'
  },
  tableRowColumn: {
    textAlign: 'center'
  }
}

export {
  styles
}
